'use strict';

// =================================================================
//  mco-buybox.js — Volume Discount Buy Box (MAC-015)
//  Producción — comportamiento únicamente, HTML generado por Liquid
// =================================================================

const MCO_BB_SEL = {
  wrapper:          '.mco-015-wrapper',
  allContainers:    '.mco-015-selector',
  activeContainer:  '.mco-015-selector.active',
  cards:            '.mco-015-card',
  selectedCard:     '.mco-015-card.mco-015-card--selected',
  tabs:             '.mco-015-tab',
  savingsBanner:    '.mco-015-savings-banner',
  savingsAmount:    '.mco-015-savings-amount',
  variantPill:      '.mco-015-variant-pill',
  atcBtn:           '#AddToCart',
  atcMobile:        '.sticky-footer.add_to_cart_holder button',
  stickyFooter:     '.sticky-footer.add_to_cart_holder',
  appstleWidget:    '#appstle_subscription_widget0',
  appstleContainer: '.mco-015-appstle-container',
  // productForm / qtyInput: necesarios solo si se migra a form.requestSubmit() (ver QA item B)
  // productForm:   'form[action*="/cart/add"]',
  // qtyInput:      'input[name="quantity"]',
  variantInputs:    'fieldset > input[type="radio"]',
};

const MCO_BB_CLS = {
  active:          'active',
  cardSelected:    'mco-015-card--selected',
  tabActive:       'mco-015-tab--active',
  savingsVisible:  'mco-015-savings-banner--visible',
  subActive:       'mco-subscription-active',
  ctaVisible:      'mco-cta-visible',
  buyboxActive:    'mco-buybox-active',
};

const MCO_BB_TIMING = {
  widgetCheckInterval:  200,
  maxWidgetChecks:      50,
  appstleClickDelay:    500,
  variantRerenderDelay: 600,
};

const mcoBbCache = {
  containers:          null,
  currentVariantId:    null,
  appstleObs:          null,
  intersectionObs:     null,
  atcInFlight:         false,   // F-14: bloquear ATC durante fetch en vuelo
  variantChangeTimers: [],      // F-11: setTimeouts encolados por cambio de variante (para cancelarlos en cambios rápidos)
};

// F-11: cancela todos los setTimeouts encolados por cambios de variante previos.
// Evita que un cambio antiguo sobreescriba el estado del cambio actual ~600-900ms después.
function mcoBbCancelVariantTimers() {
  mcoBbCache.variantChangeTimers.forEach(t => clearTimeout(t));
  mcoBbCache.variantChangeTimers = [];
}

// F-13: muestra un toast visible al usuario cuando el ATC falla (out of stock, etc.).
// Se inyecta on-demand para no añadir DOM en cada PDP. Estilos inline para no depender del CSS del buybox.
function mcoBbShowError(msg) {
  let toast = document.querySelector('.mco-bb-error-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'mco-bb-error-toast';
    toast.setAttribute('role', 'alert');
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#c0392b;color:#fff;padding:12px 20px;border-radius:8px;z-index:99999;font-size:14px;max-width:90vw;text-align:center;box-shadow:0 4px 12px rgba(0,0,0,0.2);transition:opacity 0.3s;opacity:0;';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.opacity = '1';
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => { toast.style.opacity = '0'; }, 4500);
}

// ==================== SELECCIÓN DE TARJETA ====================
function mcoBbSelectCard(card) {
  const container = card.closest(MCO_BB_SEL.allContainers);
  if (!container) return;

  container.querySelectorAll(MCO_BB_SEL.cards)
    .forEach(b => b.classList.remove(MCO_BB_CLS.cardSelected));
  card.classList.add(MCO_BB_CLS.cardSelected);

  // Mostrar/ocultar banner de ahorro según 1U / 2U
  const isDouble = card.dataset.optionType === 'double';
  const banner = document.querySelector(MCO_BB_SEL.savingsBanner);
  if (banner) {
    banner.classList.toggle(MCO_BB_CLS.savingsVisible, isDouble);
    if (isDouble) {
      const savings = container.dataset.savings;
      const el = banner.querySelector(MCO_BB_SEL.savingsAmount);
      if (el && savings) el.textContent = savings;
    }
  }
}

// ==================== CAMBIO DE VARIANTE ====================
function mcoBbUpdateVariantContainer(variantId) {
  if (!mcoBbCache.containers) {
    mcoBbCache.containers = Array.from(document.querySelectorAll(MCO_BB_SEL.allContainers));
  }
  const current = mcoBbCache.containers.find(c => c.classList.contains(MCO_BB_CLS.active));
  if (current?.dataset.variantId === String(variantId)) return;

  // F-11: cancelar setTimeouts encolados por cambios de variante previos.
  // Sin esto, en cambios rápidos (30g→200g→80g en <300ms) los timers del primer cambio
  // disparan ~600ms después y reescriben el estado del último cambio.
  mcoBbCancelVariantTimers();

  // Preservar tipo de tarjeta seleccionada (single/double) al cambiar variante
  let selectedType = 'single';
  if (current) {
    const sel = current.querySelector(MCO_BB_SEL.selectedCard);
    if (sel) selectedType = sel.dataset.optionType;
  }

  mcoBbCache.containers.forEach(c => {
    const isTarget = c.dataset.variantId === String(variantId);
    c.classList.toggle(MCO_BB_CLS.active, isTarget);
    if (!isTarget) return;

    // Restaurar selección de tarjeta en el nuevo contenedor
    const cards = c.querySelectorAll(MCO_BB_SEL.cards);
    const target = c.querySelector(`.mco-015-card[data-option-type="${selectedType}"]`) || cards[0];
    cards.forEach(b => b.classList.toggle(MCO_BB_CLS.cardSelected, b === target));

    // Actualizar banner de ahorro si 2U sigue seleccionada
    if (selectedType === 'double') {
      const savings = c.dataset.savings;
      const banner = document.querySelector(MCO_BB_SEL.savingsBanner);
      const el = banner?.querySelector(MCO_BB_SEL.savingsAmount);
      if (el && savings) el.textContent = savings;
    }

    // Actualizar pill de variante activa
    const pill = document.querySelector(MCO_BB_SEL.variantPill);
    if (pill) pill.textContent = c.dataset.variantTitle || '';

    // Si estamos en modo suscripción: mover Appstle al nuevo contenedor.
    // El theme re-renderiza el bloque de ATC ~600ms después de cambiar variante
    // y puede devolver el widget a su posición original → re-mover tras ese delay.
    if (document.body.classList.contains(MCO_BB_CLS.subActive)) {
      mcoBbMoveAppstle();
      mcoBbClickAppstleSellingPlan();
      const rerunTimer = setTimeout(() => {
        if (document.body.classList.contains(MCO_BB_CLS.subActive)) {
          mcoBbMoveAppstle();
          mcoBbClickAppstleSellingPlan();
        }
      }, MCO_BB_TIMING.variantRerenderDelay);
      mcoBbCache.variantChangeTimers.push(rerunTimer);
    }
  });
}

// ==================== TAB TOGGLE ====================
function mcoBbActivateTab(tab) {
  document.querySelectorAll(MCO_BB_SEL.tabs)
    .forEach(b => b.classList.remove(MCO_BB_CLS.tabActive));
  tab.classList.add(MCO_BB_CLS.tabActive);

  const isSub = tab.dataset.tab === 'sub';
  document.body.classList.toggle(MCO_BB_CLS.subActive, isSub);
  mcoBbToggleAppstle(isSub);
}

// ==================== APPSTLE ====================
function mcoBbMoveAppstle() {
  const widget = document.querySelector(MCO_BB_SEL.appstleWidget);
  const container = document.querySelector(
    MCO_BB_SEL.activeContainer + ' ' + MCO_BB_SEL.appstleContainer
  );
  if (widget && container && !container.contains(widget)) {
    container.appendChild(widget);
  }
}

function mcoBbClickAppstleSellingPlan() {
  // Selecciona el radio input del plan Appstle con id appstle_selling_plan_label_20.
  // NOTA: el selector apunta al INPUT (radio), no al label — el label solo activa
  // si el input no está deshabilitado.
  let n = 0;
  const check = () => {
    const label = document.querySelector('#appstle_selling_plan_label_20');
    if (label && !label.disabled) {
      label.click();
      mcoBbSelectAppstleFrequency();
      return true;
    }
    if (++n < 10) {
      const retryTimer = setTimeout(check, MCO_BB_TIMING.appstleClickDelay);
      mcoBbCache.variantChangeTimers.push(retryTimer); // F-11: trackeable para cancelar
    }
    return false;
  };
  const initialTimer = setTimeout(check, MCO_BB_TIMING.appstleClickDelay);
  mcoBbCache.variantChangeTimers.push(initialTimer); // F-11
}

function mcoBbSelectAppstleFrequency() {
  // La frecuencia recomendada está pre-computada en data-frequency del .mco-015-selector.active
  const active = document.querySelector(MCO_BB_SEL.activeContainer);
  const targetMonths = parseInt(active?.dataset.frequency || '1', 10);
  const labels = document.querySelectorAll(
    '#appstle_subscription_widget0 label[for^="appstle_subscription_widget0-"]'
  );
  if (!labels.length) return;
  const target = Array.from(labels).find(l => {
    const num = l.textContent.match(/\d+/);
    return num && parseInt(num[0], 10) === targetMonths;
  }) || labels[0];
  if (target) target.click();
}

function mcoBbToggleAppstle(isActive) {
  const widget = document.querySelector(MCO_BB_SEL.appstleWidget);
  if (!widget) return;
  if (isActive) {
    mcoBbMoveAppstle();
    mcoBbClickAppstleSellingPlan();
  } else {
    // Al volver a "compra única": resetear estado de Appstle.
    // Sin este click, Appstle conserva el plan seleccionado en sus inputs nativos
    // y el ATC incluiría un selling_plan aunque el usuario eligiera compra única.
    const noRadio = document.querySelector(
      '#appstle_subscription_widget0 .appstle_subscription_wrapper_option:first-child input[type="radio"]'
    );
    if (noRadio && !noRadio.checked) noRadio.click();
  }
}

function mcoBbWaitForAppstle() {
  let n = 0, done = false;
  let interval = null, observer = null;

  const stopAll = () => {
    done = true;
    if (interval) { clearInterval(interval); interval = null; }
    if (observer) { observer.disconnect(); observer = null; mcoBbCache.appstleObs = null; }
  };

  const handleReady = () => {
    if (done) return true;
    const widget = document.querySelector(MCO_BB_SEL.appstleWidget);
    if (!widget) return false;
    mcoBbMoveAppstle();
    if (document.body.classList.contains(MCO_BB_CLS.subActive)) {
      mcoBbClickAppstleSellingPlan();
    }
    stopAll();
    return true;
  };

  interval = setInterval(() => {
    if (handleReady() || ++n >= MCO_BB_TIMING.maxWidgetChecks) {
      if (interval) { clearInterval(interval); interval = null; }
    }
  }, MCO_BB_TIMING.widgetCheckInterval);

  observer = new MutationObserver(handleReady);
  observer.observe(document.body, { childList: true, subtree: true });
  mcoBbCache.appstleObs = observer;
}

function mcoBbGetAppstleSellingPlan() {
  if (!document.body.classList.contains(MCO_BB_CLS.subActive)) return null;
  const widget = document.querySelector(MCO_BB_SEL.appstleWidget);
  if (!widget) return null;
  const plan = widget.getAttribute('data-selected-selling-plan');
  if (plan) return plan;
  const radio = widget.querySelector('input[type="radio"]:checked');
  return radio ? (radio.value || radio.getAttribute('data-selling-plan-id')) : null;
}

// ==================== STICKY CTA ====================
function mcoBbInitStickyControl() {
  const cta = document.querySelector(MCO_BB_SEL.atcBtn);
  const sticky = document.querySelector(MCO_BB_SEL.stickyFooter);
  if (!cta || !sticky) return;
  mcoBbCache.intersectionObs = new IntersectionObserver(
    entries => entries.forEach(e =>
      document.body.classList.toggle(MCO_BB_CLS.ctaVisible, e.isIntersecting)
    ),
    { threshold: 0.1, rootMargin: '-50px 0px 0px 0px' }
  );
  mcoBbCache.intersectionObs.observe(cta);
}

// ==================== ADD TO CART ====================
function mcoBbAddToCart() {
  // F-14: anti doble click. Si hay un fetch ATC en vuelo, ignorar este click.
  // Cubre tanto el ATC principal (#AddToCart) como el sticky mobile (mismo flag global).
  if (mcoBbCache.atcInFlight) return;

  const active = document.querySelector(MCO_BB_SEL.activeContainer);
  if (!active) return;

  const isSub = document.body.classList.contains(MCO_BB_CLS.subActive);
  let quantity = 1;
  if (!isSub) {
    const selected = active.querySelector(MCO_BB_SEL.selectedCard);
    if (!selected) return;
    quantity = selected.dataset.optionType === 'double' ? 2 : 1;
  }

  const checkedRadio = document.querySelector('fieldset > input[type="radio"]:checked');
  let variantId = checkedRadio
    ? checkedRadio.getAttribute('data-variant-id')
    : new URLSearchParams(window.location.search).get('variant');
  if (!variantId) return;

  const itemData = { id: variantId, quantity };
  const sellingPlan = mcoBbGetAppstleSellingPlan();
  if (sellingPlan) itemData.selling_plan = sellingPlan;

  // F-14: marcar fetch en vuelo
  mcoBbCache.atcInFlight = true;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ items: [itemData] })
  })
  .then(async r => {
    // F-13: parsear el body aunque la respuesta sea !ok, para extraer el mensaje
    const ct = r.headers.get('content-type') || '';
    const data = ct.includes('json') ? await r.json().catch(() => null) : null;

    if (!r.ok) {
      // F-13: error de Shopify (422 sold out, 404 variant no existe, etc.) → mostrar al usuario
      const msg = data?.description || data?.message || 'No se pudo añadir al carrito. Inténtalo de nuevo.';
      console.error('[mco-buybox] Cart add error:', r.status, msg, data);
      mcoBbShowError(msg);
      return null;
    }
    return data;
  })
  .then(data => {
    if (!data) return;
    // Intentar actualizar UI del carrito con los mecanismos conocidos del tema
    if (typeof window.theme?.getCart === 'function') window.theme.getCart();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  })
  .catch(e => {
    // F-13: network errors (sin conexión, CORS, etc.)
    console.error('[mco-buybox] ATC network error:', e);
    mcoBbShowError('Sin conexión. Revisa tu red e inténtalo de nuevo.');
  })
  .finally(() => {
    // F-14: liberar el flag para permitir clicks siguientes
    mcoBbCache.atcInFlight = false;
  });
}

function mcoBbAttachATC(btn) {
  if (!btn) return;
  // Capture phase: interceptar antes de que el tema procese el click
  btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); mcoBbAddToCart(); }, true);
}

// ==================== CLEANUP ====================
function mcoBbCleanup() {
  if (mcoBbCache.appstleObs)      { mcoBbCache.appstleObs.disconnect();      mcoBbCache.appstleObs      = null; }
  if (mcoBbCache.intersectionObs) { mcoBbCache.intersectionObs.disconnect(); mcoBbCache.intersectionObs = null; }
}

// ==================== INIT ====================
function mcoBbInit() {
  // El snippet solo renderiza si buybox_enabled = true.
  // Verificar por si acaso (ej. carga asíncrona).
  if (!document.querySelector(MCO_BB_SEL.wrapper)) return;

  try {
    // body.mco-buybox-active ya fue añadido por el inline script del snippet
    // pero lo reafirmamos aquí por si el inline script no ejecutó (caching raro)
    document.body.classList.add(MCO_BB_CLS.buyboxActive);

    requestAnimationFrame(() => {
      // 1. Listeners en radio buttons de variantes (tamaño/sabor)
      document.querySelectorAll(MCO_BB_SEL.variantInputs).forEach(input => {
        input.addEventListener('change', () => {
          mcoBbCache.currentVariantId = input.getAttribute('data-variant-id');
          mcoBbUpdateVariantContainer(mcoBbCache.currentVariantId);
        });
      });

      // 2. Sincronizar contenedor activo con la variante de la URL (?variant=...).
      //    El snippet marca como .active el primer contenedor por defecto; si la
      //    URL trae otra variante, conmutamos antes de inicializar el resto.
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      if (urlVariantId) mcoBbUpdateVariantContainer(urlVariantId);

      // 3. Event delegation en el wrapper (tarjetas + tabs)
      const wrapper = document.querySelector(MCO_BB_SEL.wrapper);
      if (wrapper) {
        wrapper.addEventListener('click', e => {
          const card = e.target.closest(MCO_BB_SEL.cards);
          if (card) { e.preventDefault(); mcoBbSelectCard(card); return; }
          const tab = e.target.closest(MCO_BB_SEL.tabs);
          if (tab) mcoBbActivateTab(tab);
        });
      }

      // 4. ATC: botón principal y sticky footer
      mcoBbAttachATC(document.querySelector(MCO_BB_SEL.atcBtn));
      mcoBbAttachATC(document.querySelector(MCO_BB_SEL.atcMobile));

      mcoBbInitStickyControl();

      // 5. F-12: si la URL trae ?selling_plan=..., activar el tab "Suscríbete" antes
      //    de que mcoBbWaitForAppstle empiece a mover el widget. Así el body class
      //    y el tab quedan sincronizados con el estado de Appstle desde el primer paint.
      if (urlParams.get('selling_plan')) {
        const subTab = document.querySelector('.mco-015-tab[data-tab="sub"]');
        if (subTab) mcoBbActivateTab(subTab);
      }

      // 6. Esperar al widget Appstle y moverlo al contenedor activo
      mcoBbWaitForAppstle();
    });

    window.addEventListener('beforeunload', mcoBbCleanup);

  } catch (e) {
    console.error('[mco-buybox] Error init:', e);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mcoBbInit);
} else {
  mcoBbInit();
}